import { render, staticRenderFns } from "./RegisterManagement.vue?vue&type=template&id=6ecf936e&scoped=true"
import script from "./RegisterManagement.vue?vue&type=script&lang=js"
export * from "./RegisterManagement.vue?vue&type=script&lang=js"
import style0 from "./RegisterManagement.vue?vue&type=style&index=0&id=6ecf936e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf936e",
  null
  
)

export default component.exports